export default "__VITE_ASSET__29736f5c__"